// redux/store.js (or your store file)

import { applyMiddleware, compose, createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import rootReducers from "Redux/reducer/root.reducer";

// Persist config
const persistConfig = {
  key: "root",
  storage,
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducers);

// Enable Redux DevTools Extension if available
const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create Redux store
const store = createStore(
  persistedReducer,
  composeEnhancers(
    applyMiddleware() // Add middleware like redux-thunk here if needed
  )
);

// Persistor for redux-persist
const persistor = persistStore(store);

// Export store and persistor
export { persistor };
export default store;
